import { APP_DOMAIN } from '../config';

export const getTenant = () => {
  const host = window.location.hostname;
  const domain = APP_DOMAIN;

  if (!domain) return 'public';

  if (host === domain) {
    return 'public';
  }

  if (host.endsWith(`.${domain}`)) {
    return host.replace(`.${domain}`, '');
  }

  return 'public';
};